<script lang="ts">
    import { defineComponent } from "vue"
    import { VBtn } from "vuetify/lib"

    export default defineComponent({
        extends: VBtn,
        props: {
            elevation: {
                type: Number,
                default: 0,
            },
        },
    })
</script>
